import {BasicSymbolType} from "../../../core/reel/symbol/config/IReelSymbolStruct";
import {GameConfig} from "../../config/base/GameConfig";
import {IWinRatioConfig} from "../../config/base/IWinConfig";
import {IAllWinData, IBetWayWinData} from '../base/IData';
import {Helper} from "../../../core/utils/Helper";
import {ArrayHelper} from "../../../core/utils/ArrayHelper";
import {CoreData} from "./CoreData";
import {GameMode} from '@nolimitcity/slot-game/bin/flowcontrol/GameMode';
import {PRGameMode} from "../PRGameMode";
import {PREngineManager} from "../../punkEngine/PREngineManager";


export class ReelGameData extends CoreData {

    protected _reelsNextSpin: string;

    public get reelsNextSpin(): string {
        return this._reelsNextSpin = Helper.fetchOrApply(this.data.nextMode, this.data.mode);
    }

    public get reels(): string[][] {
        return this.data.reels;
    }

    public get scatterPositions(): number[] {
        return this.fetchSymbolPos(BasicSymbolType.SCATTER, this._windowReel, true) as number[];
    }

    public get mysteryPos(): number[] {
        return this.fetchSymbolPos("M", this._windowReel, true) as number[];
    }

    public get xWildPos(): number[] {
        return this.fetchSymbolPos("XWILD", this._windowReel, true) as number[];
    }

    public get wildSinglePos(): number[] {
        return this.fetchSymbolPos("W", this._windowReel, true) as number[];
    }

    public get amountOfScatters(): number {
        return this.countTotalAmountOfType(BasicSymbolType.SCATTER, this.reels);
    }

    public get symbolSizes(): number[][] {
        return Helper.fetchOrApply(this.data.symbolSizes, [[]]);
    }

    public get gameAreaSize(): number[] {
        const gameAreaSize: number[] = [],
            symSizes: number[][] = this.data.symbolSizes;

        for (let i: number = 0; i < symSizes.length; i++) {
            gameAreaSize[i] = symSizes[i].reduce((a, b) => a + b, 0);
        }

        return gameAreaSize;
        //return this.data.gameAreaSize;// Helper.fetchOrApply(ArrayHelper.initArrayWithValues(this.data.reels.length, (i) => this.reelModeHeight), []);
    }

    apply(data: any): void {
        super.apply(data);
    }

    public calculateMultiWaysValues(modeName: GameMode): number[] {
        const temp: number[] = [],
            nrOfReels: number = 6;

        let calcValues: number[] = ArrayHelper.initArrayWithValues(nrOfReels, () => 3);

        if (modeName === PRGameMode.NORMAL) {
            for (let reel: number = 0; reel < nrOfReels; reel++) {
                calcValues[reel] = this.gameAreaSize[reel];

                let totalWays: number = calcValues[0];
                for (let i: number = 1; i < calcValues.length; i++) {
                    totalWays *= calcValues[i];
                }
                temp.push(totalWays);
            }
        } else if (modeName === PRGameMode.RESPIN) {
            PREngineManager.AllReels.forEach(currReel => {
                if (currReel.isActive) {
                    calcValues[currReel.reelID] = (this.data.mode === PRGameMode.RESPIN) ? this.gameAreaSize[currReel.reelID] : 3;
                } else {
                    calcValues[currReel.reelID] = this.gameAreaSize[currReel.reelID];
                }
            });

            for (let reel: number = 0; reel < nrOfReels; reel++) {
                let totalWays: number = calcValues[0];
                for (let i: number = 1; i < calcValues.length; i++) {
                    totalWays *= calcValues[i];
                }
                temp.push(totalWays);
            }
        } else {
            for (let reel: number = 0; reel < nrOfReels; reel++) {
                let totalWays: number = calcValues[0];
                for (let i: number = 1; i < calcValues.length; i++) {
                    totalWays *= calcValues[i];
                }
                temp.push(totalWays);
            }
        }

        return temp;
    }
}

export class WinGameData extends CoreData {

    private _winData: IBetWayWinData[] = [];
    private _allBetWayWinData: IAllWinData;

    public get allBetWayWinData(): IAllWinData {
        return this._allBetWayWinData;
    }

    public get totalWinCombination(): number {
        return Helper.fetchOrApply(this.allBetWayWinData.totalWinCombination, 0);
    }

    public get brokeTheBank(): boolean {
        return Helper.fetchOrApply(this.data.brokeTheBank, false);
    }

    public get totalWin(): number {
        return Helper.fetchOrApply(this.data.accumulatedRoundWin, 0);
    }

    public get singleWin(): number {
        return Helper.fetchOrApply(this.data.totalSpinWinnings, 0)
    }

    public get playedBetValue(): number {
        return Helper.fetchOrApply(this.data.playedBetValue, 0)
    }

    public get betWayWins(): IBetWayWinData[] {
        return this._winData;
    }

    public get winRatio(): number {
        return this.singleWin / this.playedBetValue;
    }

    public get evalSize(): number {
        return this.data.evaluatedArea ? ArrayHelper.countWithCondition(this.data.evaluatedArea[0], (s) => s != "X") : 3;
    }

    public get isBigWin(): boolean {
        return this.winRatio > GameConfig.WIN_RATIOS.bigWin[0].ratio * 1.2;
    }

    public get winRatioConfig(): IWinRatioConfig {
        return this.getWinRatioConfig(this.winRatio, GameConfig.WIN_RATIOS.normalWin.concat().concat(GameConfig.WIN_RATIOS.bigWin));
    }

    apply(data: any): void {
        super.apply(data);

        this._winData = this.data.evaluatedArea ? this.addBetLvls(this.createBetWaysWins(this.updatedEval, this.data.betWayWins), this.playedBetValue, GameConfig.WIN_RATIOS!.normalWin) : [];
        this._winData.sort((a, b) => b.amount - a.amount);

        this._allBetWayWinData = this.parseAllHits(this._winData, this.data.reels.length, this.evalSize);
    }
}